export class StorageService {
  static STORAGE_KEY = 'refine_release_cohort';
  static PROGRESS_KEY = 'lesson_progress';

  static getLessonData(lessonNumber) {
    try {
      const data = localStorage.getItem(`${this.STORAGE_KEY}_lesson_${lessonNumber}`);
      return data ? JSON.parse(data) : {};
    } catch (error) {
      console.error('Error loading lesson data:', error);
      return {};
    }
  }

  static saveLessonData(lessonNumber, data) {
    try {
      localStorage.setItem(`${this.STORAGE_KEY}_lesson_${lessonNumber}`, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving lesson data:', error);
    }
  }

  static getLessonProgress() {
    try {
      const data = localStorage.getItem(`${this.STORAGE_KEY}_${this.PROGRESS_KEY}`);
      return data ? JSON.parse(data) : {};
    } catch (error) {
      console.error('Error loading progress:', error);
      return {};
    }
  }

  static saveLessonProgress(progress) {
    try {
      localStorage.setItem(`${this.STORAGE_KEY}_${this.PROGRESS_KEY}`, JSON.stringify(progress));
    } catch (error) {
      console.error('Error saving progress:', error);
    }
  }

  static getAllReflections() {
    const allData = {};
    for (let i = 1; i <= 8; i++) {
      allData[i] = this.getLessonData(i);
    }
    return allData;
  }

  static formatForExport(allData, format = 'txt') {
    const lessonTitles = {
      1: 'The Manuscript Readiness Audit',
      2: 'Editing for the Reader\'s Experience',
      3: 'The Self-Editing System (Cycling vs. Rewriting)',
      4: 'Scene, Sentence, and Soul',
      5: 'Publishing Pathways Simplified',
      6: 'Book Setup Basics (Metadata & Files)',
      7: 'Your Simple Launch Plan',
      8: 'Stewarding Your Story Beyond Launch'
    };

    let content = '';
    const date = new Date().toLocaleDateString();

    if (format === 'md') {
      content += `# My Refine + Release Journey\n\n`;
      content += `**Exported:** ${date}\n`;
      content += `**Cohort:** Write. Refine. Release.\n`;
      content += `**Brand:** CROSS + PEN | GospelWise Author\n\n`;
      content += `---\n\n`;
    } else {
      content += `MY REFINE + RELEASE JOURNEY\n`;
      content += `${'='.repeat(50)}\n\n`;
      content += `Exported: ${date}\n`;
      content += `Cohort: Write. Refine. Release.\n`;
      content += `Brand: CROSS + PEN | GospelWise Author\n\n`;
    }

    Object.entries(allData).forEach(([lessonNumber, data]) => {
      const hasData = Object.values(data).some(value => value && value.trim());
      if (!hasData) return;

      if (format === 'md') {
        content += `## Lesson ${lessonNumber}: ${lessonTitles[lessonNumber]}\n\n`;
      } else {
        content += `LESSON ${lessonNumber}: ${lessonTitles[lessonNumber]}\n`;
        content += `${'-'.repeat(40)}\n\n`;
      }

      Object.entries(data).forEach(([key, value]) => {
        if (!value || !value.trim()) return;
        
        const fieldName = key
          .replace(/lesson\d+_/, '')
          .replace(/_/g, ' ')
          .replace(/\b\w/g, l => l.toUpperCase());

        if (format === 'md') {
          content += `**${fieldName}:**\n${value}\n\n`;
        } else {
          content += `${fieldName}:\n${value}\n\n`;
        }
      });

      content += format === 'md' ? `---\n\n` : `\n`;
    });

    if (format === 'md') {
      content += `## Reflection\n\n`;
      content += `*"Lord, help me see my work clearly — not through pride or fear, but through Your eyes of purpose and possibility."*\n\n`;
      content += `Generated by the Refine. Release. Cohort Companion\n`;
      content += `CROSS + PEN | GospelWise Author`;
    } else {
      content += `REFLECTION\n`;
      content += `${'-'.repeat(40)}\n\n`;
      content += `"Lord, help me see my work clearly — not through pride or fear,\n`;
      content += `but through Your eyes of purpose and possibility."\n\n`;
      content += `Generated by the Refine. Release. Cohort Companion\n`;
      content += `CROSS + PEN | GospelWise Author`;
    }

    return content;
  }

  static clearAllData() {
    try {
      // Clear lesson data
      for (let i = 1; i <= 8; i++) {
        localStorage.removeItem(`${this.STORAGE_KEY}_lesson_${i}`);
      }
      // Clear progress
      localStorage.removeItem(`${this.STORAGE_KEY}_${this.PROGRESS_KEY}`);
    } catch (error) {
      console.error('Error clearing data:', error);
    }
  }
}